<template>
    <div>
        <div class="common-header-wrap">
            <mt-header class="common-header" title="积分代金券">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="list-wrap" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <index-voucher-item class="list-wrap-item" v-for="item in voucherList" :key="item.vouchertemplate_id" :item="item">
            </index-voucher-item>
        </div>
        <empty-record  v-if="voucherList.length === 0"></empty-record>
    </div>
</template>

<script>
import { Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import IndexVoucherItem from './IndexVoucherItem'
import { getPointVoucherList } from '../../../api/homePointsgoods'
export default {
  name: 'index',
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      pageTotal: 1, // 总页数
      voucherList: [] // 商品列表
    }
  },
  components: {
    EmptyRecord,
      IndexVoucherItem
  },
  methods: {
    getPointVoucherList (ispush) {
      Indicator.open()
      let params = this.params
      getPointVoucherList(params).then(res => {
        Indicator.close()

        if (ispush) {
          this.voucherList = this.voucherList.concat(res.result.voucherlist)
        } else {
          this.voucherList = res.result.voucherlist
        }
        this.pageTotal = res.result.page_total
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore && this.params.page <= this.pageTotal) {
        this.loading = false
        this.getPointVoucherList(true)
      }
    },
  }
}
</script>

<style scoped lang="scss">
    .list-wrap {padding:0 15px}
    .list-wrap .list-wrap-item {display: inline-block;margin-top: 10px;width:50%;}
    .list-wrap .list-wrap-item:nth-child(2n+2) {text-align: right}
</style>
